module.exports = __webpack_public_path__ + "static/media/ARW-logo.d91cfac5.png";